import { render, staticRenderFns } from "./SopClipboardSection.vue?vue&type=template&id=0521e617&scoped=true&"
import script from "./SopClipboardSection.vue?vue&type=script&lang=ts&"
export * from "./SopClipboardSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0521e617",
  null
  
)

export default component.exports